import ActionTypes from '../constants';

const initialState = {
    paymentTypes: {},
    paymentType: {}
    // loading: false,
};

const paymentTypeReducer = (state = initialState, action) => {
    switch (action.type) {
        // case ActionTypes.LOADING:
        //     return {
        //         ...state,
        //         loading: true
        //     }
        case ActionTypes.GETPAYMENTTYPESUCCESS:
            return {
                ...state,
                paymentTypes: action.payload,
            }
        case ActionTypes.GETPAYMENTTYPEBYIDSUCCESS:
            return {
                ...state,
                paymentType: action.payload,
            }
        default:
            return state;
    }
}

export default paymentTypeReducer;